// Resolver de "entrada no Wealth Service" pela navegação client-centric —
// registrado em ws/index.js. Sem chamada de backend: sempre navega direto pra
// carteira do cliente ativo (ws.clients.codigo), pulando o dashboard agregado
// (ws.clients, que lista TODOS os clientes do escritório). Sem modal — a
// "entrada" aqui é 100% de rota (ver navegacao-v2-sidebar.vue applyClienteEntrance).
export function resolveWsClienteEntrance({ client } = {}) {
  const idClienteApp = client && client.id
  return {
    routeName: 'ws.clients.codigo',
    params: { codigo: idClienteApp },
  }
}
